module.exports = __webpack_public_path__ + "img/w78.782e1280.svg";